'use strict';

window.TES = window.TES || {};

window.TES.following = (function() {

    var id, followButton, unfollowButton;

    var showFollow = function() {
        followButton.hide();
        unfollowButton.show();
    };

    var showUnfollow = function() {
        followButton.show();
        unfollowButton.hide();
    };

    var follow = function () {
        $.ajax({
            dataType: 'json',
            type: 'GET',
            url: '/ResourcesHandler.ashx?follow=' + id,
            success: showFollow
        });
    };

    var unFollow = function () {
        $.ajax({
            dataType: 'json',
            type: 'GET',
            url: '/ResourcesHandler.ashx?unfollow=' + id,
            success: showUnfollow
        });
    };

    var initAuthenticatedUserState = function() {

        followButton.on('click', follow);
        unfollowButton.on('click', unFollow);

        followButton.attr('href', '#');

        $.getJSON('/favsfollowing/api/following/get?id=' + id)
            .done(function (state) {
                state.Following ? showFollow() : showUnfollow();
            });
    };

    return {

        init: function() {
            id = $('#lnkAuthorName').attr('data-author-id');
            followButton = $('#followButton a.follow');
            unfollowButton = $('#followButton a.unfollow');

            var user = window.TES.user;
            if (user.isAuthenticated()) {
                initAuthenticatedUserState();
            }
        }
    };
}());

$(function () {
    window.TES.following.init();
});
